<div class="rooms-container mb-col-12">
  <room
    [isMobile]="true"
    [isHomestay]="isHomestay"
    *ngFor="let room of cluster.rooms; let i = index"
    [room]="room"
    [idHotel]="hotelAvailabilityInfo.id"
    [roomsDetail]="hotelAvailabilityInfo.rooms_detail"
    [mealPlan]="cluster.rates[0]?.meal_plan"
    [index]="i"
    [numberRoom]="i + 1"
    [latestRooms]="cluster.rates[0]?.latest_rooms"
  ></room>
</div>
<div *ngIf="cluster?.rates?.length" class="rates-container mb-grid-container-full">
  <div
    *ngFor="let rate of cluster.rates | isEconomic: rate"
    class="rate mb-grid-row mb-grid-container-full">
    <meal-plan
      [isMobile]="true"
      class="meal-plan mb-grid-col-4"
      [beds]="bedInfo"
      [rate]="rate"
    ></meal-plan>
    <payment-advise
      [isMobile]="true"
      [rate]="rate"
      [argentina]="isArgentina"
      class="mb-grid-col-4"
      [isExperts]="false"
    ></payment-advise>
    <total-price
      class="mb-grid-col-4 mb-grid-row"
      style="border-top: 0.5px solid #ccc; margin-top: 10px"
      [isMobile]="true"
      [rateInput]="rate"
      [clusterInput]="cluster"
      [experts]="false"
      [showAmountTotal]="showAmountTotal"
      [priceByValue]="priceByValue"
      [hotelStaticInfo]="hotelStaticInfo"
      [hotelAvailabilityInfo]="hotelAvailabilityInfo"
    ></total-price>
  </div>
</div>
